/* global process */
import { defaultConfig } from 'app/config/environment';
import { CLIENT, FIXED_LAYOUT_TEMPLATES } from 'core/variables/constant';
import { flatten } from 'lodash';
import moment from 'moment/moment';
import { isEditorial, isStudent } from './users';
/**
 * Funciones utiles comunes para cualquier archivo js
 */

/**
 * Detecta si el cliente actual es Edelvives
 * @param {string} [client] - El identificador del cliente (opcional, se detecta automáticamente si no se proporciona)
 * @param {Object} [tenant] - El objeto tenant (opcional)
 * @returns {boolean} - true si es Edelvives, false en caso contrario
 */
export function isEdelvives(client, tenant) {
  // Primera comprobación: verificar por variable de entorno CLIENT
  if (typeof process !== 'undefined' && process.env && process.env.CLIENT === CLIENT.EDELVIVES) {    
    return true;
  }

  // Si se proporciona el client, usarlo directamente
  if (client) {
    return client === CLIENT.EDELVIVES;
  }

  // Si se proporciona el tenant, verificar por name o guid
  if (tenant) {
    return tenant?.name === CLIENT.EDELVIVES || tenant?.guid === CLIENT.EDELVIVES;
  }

  // Verificar por puerto 3003 (puerto específico de Edelvives en desarrollo)
  if (typeof window !== 'undefined' && window.location?.port === '3003') {
    return true;
  }

  // Fallback: verificar por hostname
  return typeof window !== 'undefined' && window.location?.hostname?.includes('edelvives');
}

/**
 * Detecta si el cliente actual es ByME (GotItByME)
 * @param {string} [client] - El identificador del cliente (opcional, se detecta automáticamente si no se proporciona)
 * @param {Object} [tenant] - El objeto tenant (opcional)
 * @returns {boolean} - true si es ByME, false en caso contrario
 */
export function isByme(client, tenant) {
  // Primera comprobación: verificar por variable de entorno CLIENT
  if (typeof process !== 'undefined' && process.env?.CLIENT === CLIENT.GOTITBYME) {
    return true;
  }

  // Si se proporciona el client, usarlo directamente
  if (client) {
    return client === CLIENT.GOTITBYME;
  }

  // Si se proporciona el tenant, verificar por name o guid
  if (tenant) {
    return tenant?.name === CLIENT.GOTITBYME || tenant?.guid === CLIENT.GOTITBYME;
  }

  // Fallback: verificar por hostname
  return globalThis.window?.location?.hostname?.includes('gotitbyme') ?? false;
}

/**
 * Devuelve true si estamos en modo debug
 */
export function isModeDebug() {
  return !isModeProduction();
}

export function isModeProduction() {
  return process.env.NODE_ENV === 'production';
}

export function isInPublisher(defaultConfig) {
  return (defaultConfig.PUBLISHER_DOMAIN && window.location.hostname.indexOf(defaultConfig.PUBLISHER_DOMAIN) !== -1) || false;
}

/**
 * Devuelve las opciones traduciendo su campo label
 * @param {array} options
 * @param {function} t
 */
export function getOptionsTranslateLabel(options, t) {
  const optionsToRet = [];
  options &&
    options.map((option) => {
      optionsToRet.push({ ...option, label: t(option.label) });
    });
  return optionsToRet;
}

/**
 * Copia un text al portapapeles
 * @param {string} text
 */
export function copyClipboard(text) {
  navigator.clipboard.writeText(text);
}

/**
 * Parse File to base64
 * @param {object} file
 */
export function parseFileToBase64(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = function () {
      resolve(btoa(reader.result));
    };
    reader.onerror = function () {
      reject();
    };
  });
}

export function getDateFileFormat() {
  let now = new Date();
  return '' + now.getFullYear() + now.getMonth() + now.getDay() + now.getHours() + now.getMinutes();
}

export const getDateFormatted = (date) => {
  const dateDate = new Date(date);
  return moment(dateDate).format('DD-MM-YYYY hh:mm:ss');
};

// para el core
export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getNameFile(url) {
  const split = url.split('/');
  const name = split[split.length - 1];
  return name;
}

export var debounce = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export var getCurrentMYSQLDate = function () {
  var date;
  date = new Date();
  date =
    date.getUTCFullYear() +
    '-' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('00' + date.getDate()).slice(-2) +
    ' ' +
    ('00' + date.getHours()).slice(-2) +
    ':' +
    ('00' + date.getMinutes()).slice(-2) +
    ':' +
    ('00' + date.getSeconds()).slice(-2);

  return date;
};

export function getIconByDisciplineCourse(discipline) {
  let icons = [
    { guid: 'ed1', iconType: 'science' },
    { guid: 'ed10', iconType: 'chess' },
    { guid: 'ed11', iconType: 'chess' },
    { guid: 'ed12', iconType: 'chess' },
    { guid: 'ed2', iconType: 'maths' },
    { guid: 'ed3', iconType: 'language' },
    { guid: 'ed4', iconType: 'chess' },
    { guid: 'ed5', iconType: 'chess' },
    { guid: 'ed6', iconType: 'chess' },
    { guid: 'ed7', iconType: 'chess' },
    { guid: 'ed8', iconType: 'geography' },
    { guid: 'ed9', iconType: 'history' },
  ];

  let theIcon = icons.find((icon) => icon.guid === discipline);

  return theIcon ? theIcon.iconType : 'science';
}

export function calculateUnitConsumption(unit) {
  const lessons = unit.lessons;
  if (lessons.length === 1) return lessons[0].progress.progress;
  const allProgress = flatten(lessons.map((item) => item.progress));
  let averageProgress = allProgress.map((item) => item.progress).reduce((a, b) => a + b);
  if (!averageProgress) averageProgress = 0;
  else {
    averageProgress = averageProgress / allProgress.length;
  }
  return averageProgress;
}

export function isDisregardedProgram(course, user) {
  return course.author_role_guid && isStudent(user) ? isEditorial(course.author_role_guid) : false;
}

export function getExerciseCover(question_type_guid) {
  const covers = [
    { guid: 'QT_1', name: 'multiple-choice-single' },
    { guid: 'QT_10', name: 'text' },
    { guid: 'QT_11', name: 'select' },
    { guid: 'QT_12', name: 'drag_and_drop' },
    { guid: 'QT_13', name: 'clasification' },
    { guid: 'QT_14', name: 'match_list' },
    { guid: 'QT_15', name: 'order' },
    { guid: 'QT_16', name: 'linking_lines' },
    { guid: 'QT_17', name: 'short' },
    { guid: 'QT_18', name: 'large' },
    { guid: 'QT_19', name: 'other' },
    { guid: 'QT_2', name: 'multiple-choice-multiple' },
    { guid: 'QT_20', name: 'draw' },
    { guid: 'QT_21', name: 'click_to_find' },
    { guid: 'QT_3', name: 'multiple-choice-true-false' },
    { guid: 'QT_4', name: 'multiple-choice-block-letter' },
    { guid: 'QT_5', name: 'choice-matrix-table' },
    { guid: 'QT_6', name: 'choice-matrix-inline' },
    { guid: 'QT_7', name: 'text' },
    { guid: 'QT_8', name: 'drag_and_drop' },
    { guid: 'QT_9', name: 'math' },
    { guid: 'QT_23', name: 'manual-audio-recorder' },
  ];

  let selectedCover = covers.find((cover) => cover.guid === question_type_guid);

  return selectedCover ? selectedCover.name : null;
}

export function getExerciseLabel(elements, t) {
  return elements
    .map((element) => {
      return {
        ...element,
        label: t('types-questions:' + element['guid']),
      };
    })
    .sort(function (a, b) {
      return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
    });
}

export function s2ab(s) {
  var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf); //create uint8array as viewer
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
}

export function parseScore(score) {
  try {
    score = parseFloat(score.replace(',', '.'));
  } catch {
    // score no es un string parseable: se usa el fallback de abajo.
  }
  return parseFloat(score || 0);
}

export const calculateScore = (numberOfQuestions, rankingScaleOfTest, indexOfQuestion, wasTouched, currentScore) => {
  if (wasTouched) return currentScore;

  // Calcula el score base redondeado a 2 decimales
  const baseScore = Math.round((rankingScaleOfTest / numberOfQuestions) * 100) / 100;

  if (indexOfQuestion + 1 === numberOfQuestions) {
    // Última pregunta: compensa para que la suma dé exactamente rankingScaleOfTest
    const sumOfPreviousScores = (numberOfQuestions - 1) * baseScore;
    const lastScore = Math.round((rankingScaleOfTest - sumOfPreviousScores) * 100) / 100;
    return lastScore;
  }

  return baseScore;
};

/**
 * Prevent objects to be duplicated inside an array of objects
 * Uses a key to filter
 * @param {The actual array} list
 * @param {The new items to add to the array} newItems
 * @param {The property to filter the duplicates} key
 */
export function cleanObjectDuplicates(list, newItems, key) {
  let ids = new Set(list.map((d) => d[key]));
  return [...list, ...newItems.filter((d) => !ids.has(d[key]))];
}

export function getUrlBackoffice() {
  const url = defaultConfig.BASE_URL_.split('//');
  if (url.includes('digital.macmillaneducation.es/')) {
    return url[0] + '//backoffice-' + url[1];
  }
  return url[0] + (defaultConfig.BASE_URL_.includes('tangerine.oneclick.es') ? '//publisher.' : '//backoffice.') + url[1];
}

export function loadScriptFile(resourceUrl, resourceId, async = true, callback) {
  if (!document.getElementById(resourceId)) {
    const script = document.createElement('script');
    script.id = resourceId;
    script.src = resourceUrl;
    script.async = async;
    document.body.appendChild(script);
    if (callback) {
      script.addEventListener('load', callback);
    }
    return script;
  }
}

export function loadStylesFile(resourceUrl, resourceId) {
  if (!document.getElementById(resourceId)) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.id = resourceId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = resourceUrl;
    link.media = 'all';
    head.appendChild(link);
  }
}

export function isFixedLayoutTemplate(templateType) {
  return templateType === FIXED_LAYOUT_TEMPLATES.PRIMARY_FIXED_LAYOUT || templateType === FIXED_LAYOUT_TEMPLATES.PRIMARY_HYBRID_LAYOUT;
}
